import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import useTenantState from '@/states/tenant.state';
import useAuthState from '@/states/auth.state';
import { getTrialDaysRemaining } from '@/utils/subscription';

export const TrialExpirationAlert = () => {
  const [dismissed, setDismissed] = useState(false);
  const { currentTenant } = useTenantState();
  const { isSuperAdmin } = useAuthState();

  if (isSuperAdmin || dismissed) return null;

  const daysRemaining = getTrialDaysRemaining(currentTenant ?? undefined);
  if (daysRemaining === null) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm animate-slide-in-right">
      <div className="bg-amber-50 border border-amber-300 rounded-lg shadow-lg p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-amber-800 mb-1">Peringatan Uji Coba</p>
            <p className="text-sm text-amber-700">
              Masa uji coba Anda akan berakhir dalam{' '}
              <span className="font-bold">{daysRemaining} hari</span>. Untuk memastikan akses ke
              seluruh fitur tetap aktif tanpa gangguan, silakan lakukan perpanjangan langganan
              sebelum masa uji coba berakhir.
            </p>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="flex-shrink-0 p-1 rounded-md text-amber-500 hover:text-amber-700 hover:bg-amber-100 transition-colors"
            aria-label="Tutup peringatan"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
